export const COLOR = {
  brand: '#2451B2',
  brandLight: '#D1DCF2',
  brandLightAlpha: 'rgba(36, 81, 178, 0.2)',
  brandLighterAlpha: 'rgba(36, 81, 178, 0.1)',
  brandLightest: '#F4F6FB',
  brandLightestAlpha: 'rgba(36, 81, 178, 0.05)',
  success: '#2AA738',
  successLight: '#CEEED5',
  successLightAlpha: 'rgba(42, 167, 56, 0.2)',
  successLightest: '#F6FCFC',
  successLightestAlpha: 'rgba(42, 167, 56, 0.05)',
  danger: '#E13D3D',
  dangerLight: '#FFD6D7',
  dangerLightAlpha: 'rgba(225, 61, 61, 0.2)',
  dangerLightest: '#FFF5F5',
  dangerLightestAlpha: 'rgba(225, 61, 61, 0.05)',
  warning: '#F89C1B',
  warningLight: '#FEECD9',
  warningLightAlpha: 'rgba(248, 156, 27, 0.2)',
  warningLightest: '#FFFBF5',
  warningLightestAlpha: 'rgba(248, 156, 27, 0.05)',
  highlightBrand: '#4164AF',
  highlightNeon: '#3074EB',
  highlightNeonLightestAlpha: 'rgba(48, 116, 235, 0.05)',
  textPrimary: '#001C4B',
  textSecondary: '#2D4A72',
  textTertiary: '#7D8DA7',
  white: '#fff',
  modalOverlay: 'rgba(151, 161, 181, 0.7)',
  backgroundDark: '#7D8DA7',
  backgroundMedium: '#D7DCE5',
  backgroundLight: '#F8FAFC',
  borderMedium: '#D7DCE5',
  borderLight: '#E0E6F0',
  accent1: '#5784DA',
  accent2: '#289FCB',
  accent3: '#57A5DA',
  accent4: '#57DACA',
  accent5: '#6ADA57',
  accent6: '#DA7657',
  accent7: '#DA5757',
  accent8: '#DA5792',
  accent9: '#AA57DA',
  accent10: '#8A47D7',
  boxShadow: 'rgba(0, 28, 75, 0.1)',
  boxShadowLightAlpha: 'rgba(0, 28, 75, 0.05)',
  aiGradientTop: '#035FFF',
  aiGradientBottom: '#30E0EB',
} as const;
export type COLOR = (typeof COLOR)[keyof typeof COLOR];

export const GRADIENT = {
  gradientAi: 'linear-gradient(163.12deg, #035FFF 38.59%, #30E0EB 101.54%)',
  gradientBrand: 'linear-gradient(134.56deg, #265AC9 2.24%, #1B439B 100%)',
  gradientLight: `linear-gradient(180deg, ${COLOR.white} 0%, ${COLOR.backgroundLight} 100%)`,
  subcontractorPremium: `conic-gradient(from 9.87deg at 55.8% 120.83%,
    #d78721 -105.59deg,
    #fec201 16.52deg,
    #f2b906 40.97deg,
    #d78721 254.41deg,
    #fec201 376.52deg)`,
} as const;
export type GRADIENT = (typeof GRADIENT)[keyof typeof GRADIENT];
